/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {PoliticalCampaignListPageComponent} from './political-campaign-list-page.component';

@Component({
  standalone: true,
  imports: [PoliticalCampaignListPageComponent],
  selector: 'adn-political-campaign-route-page',
  template: `
    <adn-political-campaign-list-page
      [readOnly]="readOnly">
    </adn-political-campaign-list-page>
  `
})
export class PoliticalCampaignRoutePageComponent {
  @Input() readOnly = false;
}
